<script>
  import { onMount } from 'svelte'
  import { auth } from '../../services/auth.js'
  import { user } from '../../models/user.js'
  import Alert from '../../components/Alert.svelte'
  import SubmitButton from '../../components/SubmitButton.svelte'

  // PASSWORD FORM
  let oldPass = ''
  let newPass = ''
  let savingPass = false
  let passSaved = false
  let passError = null
  let savedMsg = ''
  let errorMsg = ''

  let saving = ''
  let email = ''
  let firstName = ''
  let lastName = ''
  let emailPref = false

  function savePassword() {
    if (validatePassword()) {
      savingPass = true
      auth.changePass(oldPass, newPass, showResults)
    }
  }

  onMount(() => {
    auth.getUserDetails(loadAttrs)
  })

  function loadAttrs(attrs) {
    attrs.forEach((a) => {
      if (a.name === 'email') email = a.value
      if (a.name === 'name') firstName = a.value
      if (a.name === 'family_name') lastName = a.value
      if (a.name === 'custom:emailCommunication') emailPref = a.value
    })
  }

  function savePreferences() {
    auth.updateUserDetails(
      'custom:emailCommunication',
      emailPref.toString(),
      settingResults,
    )
    user.updateSubStatus(emailPref)
  }

  function settingResults(result) {
    if (result) {
      savedMsg = 'Settings Saved!'
      setTimeout(() => (savedMsg = ''), 10000)
    } else {
      errorMsg = 'Update failed! Unknown error occurred!'
      setTimeout(() => (errorMsg = ''), 10000)
    }
  }

  function saveName() {
    if (firstName != '') {
      saving = true
      auth.updateUserDetails('name', firstName, showNameResults)
    }
    if (lastName != '') {
      saving = true
      auth.updateUserDetails('family_name', lastName, showNameResults)
    }
  }

  function validatePassword() {
    var old = document.getElementById('oldPassword')
    var pass = document.getElementById('newPassword')
    var conf = document.getElementById('confPassword')

    if (!old.checkValidity()) {
      passError = 'Invalid current password!'
      return false
    }
    if (!pass.checkValidity()) {
      passError = 'Your new password does not meet the minimum requirements!'
      return false
    }
    if (pass.value !== conf.value) {
      passError = 'You new passwords do not match!'
      return false
    }

    passError = null
    oldPass = old.value
    newPass = pass.value
    return true
  }

  function showResults(result, error) {
    savingPass = false
    passSaved = result
    passError = error

    if (passSaved) {
      document.getElementById('password-form').reset()
    }
  }

  function showNameResults(result, error) {
    saving = false
    errorMsg = error

    if (!error) {
      savedMsg = 'Updated!'
    }
  }
</script>

<h2>Settings</h2>
{#if savedMsg}
  <Alert type="success" icon="check">{savedMsg}</Alert>
{/if}

{#if errorMsg}
  <Alert type="danger" icon="warning">{errorMsg}</Alert>
{/if}
<!-- Remove for now, might add in the future
<form id="preferences-form">
  <h3>User Preferences</h3>

  <div class="form-field">
    <label>
      <input type="checkbox" bind:checked={emailPref} />
      Email Communications
    </label>
  </div> 
  <SubmitButton
    onSubmit={() => savePreferences()}
    text="Save"
  /> 
</form> -->

<h3>Email</h3>
<span>{email}</span>
<form id="name-form">
  <div class="form-field">
    <label for="firstName" class="form-label">First Name</label>
    <input id="firstName" bind:value={firstName} class="form-input" required />
  </div>
  <div class="form-field">
    <label for="lastName" class="form-label">Last Name</label>
    <input id="lastName" bind:value={lastName} class="form-input" required />
  </div>
  <div class="form-actions">
    <SubmitButton onSubmit={() => saveName()} text="Update" />
  </div>
</form>
<hr />

<form id="password-form" class="password">
  <h3>Reset Password</h3>

  {#if passError}
    <Alert type="danger" icon="warning">{passError}</Alert>
  {/if}

  {#if passSaved}
    <Alert type="success" icon="check">Your password has been updated!</Alert>
  {/if}

  <div class="form-field">
    <label for="oldPassword" class="form-label">Current Password</label>
    <input
      id="oldPassword"
      class="form-input"
      type="password"
      pattern={'(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^$*.\\[\\]{}()?-“!@#%&/,><’:;|_~`])\\S{8,99}'}
      required />
  </div>

  <div class="form-field">
    <label for="newPassword" class="form-label">New Password</label>
    <input
      id="newPassword"
      class="form-input"
      type="password"
      autocomplete="new-password"
      pattern={'(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^$*.\\[\\]{}()?-“!@#%&/,><’:;|_~`])\\S{8,99}'}
      required />
  </div>

  <div class="form-field">
    <label for="confPassword" class="form-label">Repeat New Password</label>
    <input
      id="confPassword"
      class="form-input"
      type="password"
      autocomplete="new-password"
      pattern={'(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^$*.\\[\\]{}()?-“!@#%&/,><’:;|_~`])\\S{8,99}'}
      required />
  </div>

  <div class="form-actions">
    <SubmitButton onSubmit={() => savePassword()} text="Update Password" />
  </div>
</form>
